<template>
  <vue-editor v-model="stageInfo.text_material" :editor-toolbar="customToolbar" />
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        ['link']
      ]
    }
  },
  props: {
    stageInfo: {
      default: () => {},
      type: Object
    }
  }
}
</script>
